export const ARTISTS_LIST = [
    {
        name: "ANTHONY SIEBEN",
        description: "Game of Thrones, Jurassic World, Pokémon, Marvel's Eternals, Dora, Aquaman and The Lion King",
        img: "/artists/1.png",
        to: "https://www.imdb.com/name/nm6938456",
        button: "/artists/button.svg"
    },
    {
        name: "RICARDO ALVES",
        description: "Star Wars: Rogue One and The Last Jedi, James Bond: Spectre, Assassin’s Creed, Harry Potter: Fantastic Beasts and Godzilla.",
        img: "/artists/2.png",
        to: "https://www.imdb.com/name/nm6938456",
        button: "/artists/button.svg"
    },
    {
        name: "TOM HERZIG",
        description: "Star Wars: Mandalorian, Star Trek: Discovery, Game of Thrones, Star Trek, Without Remorse.",
        img: "/artists/3.png",
        to: "https://www.imdb.com/name/nm6938456",
        button: "/artists/button.svg"
    }
]

export const MEMBERS_LIST1 = [
    {
        name: "ADAM",
        description: "FOUNDER OF THE MAU CLUB",
        img: "/team/1/1.png",        
    },
    {
        name: "JOSE",
        description: "CEO OF MAU CLUB",
        img: "/team/1/2.png",        
    },
    {
        name: "NICK",
        description: "Blockchain engineer",
        img: "/team/1/3.png",        
    },
    {
        name: "LI",
        description: "Web3 engineer",
        img: "/team/1/4.png",        
    },
    {
        name: "JOHN",
        description: "Discord engineer",
        img: "/team/1/5.png",        
    },
    {
        name: "HENRY",
        description: "Code engineer",
        img: "/team/1/6.png",        
    },
    {
        name: "DYLEN",
        description: "Social media manager",
        img: "/team/1/7.png",        
    }
]

export const MEMBERS_LIST2 = [
    {
        name: "THOMAS",
        description: "Marketing manager",
        img: "/team/2/1.png",        
    },
    {
        name: "CONNOR",
        description: "3D designer",
        img: "/team/2/2.png",        
    },
    {
        name: "ROBERT",
        description: "2D designer",
        img: "/team/2/3.png",        
    },
    {
        name: "BRUCE",
        description: "3D Graphics engineer",
        img: "/team/2/4.png",        
    },
    {
        name: "DAVID",
        description: "Moderator",
        img: "/team/2/5.png",        
    },
    {
        name: "CHRIS",
        description: "Database Developer",
        img: "/team/2/6.png",        
    },
    {
        name: "RAY",
        description: "",
        img: "/team/2/7.png",        
    },
    {
        name: "L1GHT",
        description: "",
        img: "/team/2/8.png",        
    },
    {
        name: "BRUCE",
        description: "",
        img: "/team/2/9.png",        
    },
    {
        name: "GARRET",
        description: "",
        img: "/team/2/10.png",        
    }
]

// export const FAQ_LIST=[
//     {
//         question:"When will Alpha Kong Club officially launch?",
//         answer: "According to the plan, the Club officially kicks off on 31 January. The exact time for the Raffle is 20.00 CET / 14.00 EST, only on this website. Join our discord for more information."
//     },
//     {
//         question:"How can I join?",
//         answer: "Due to the ambitious scope of the project, hundreds of thousands compete to get an exclusive Alpha Kongs Club Mint Pass. The most dedicated supporters will get first-dibs on this unique piece of 3D art."
//     },
//     {
//         question:"Is the Alpha Kongs Club a good investment?",
//         answer: (<p>Over two hundred thousand members from all over the world seem to think so. They're lining up to get their hands on their own Alpha Kongs. And for good reasons… 
//         We've got the best art from a proven team of artists who have each left their marks on the mainstream. We've pulled off the first ever NFT Festival, unprecedented in the industry with top DJs playing for you live. We've got plenty of celebrities, entrepreneurs and marketing geniuses to support us. And we're just getting started…
//         With the help of our members, we've created a real movement and step by step, we're becoming a blue chip project on the market. So let us ask the question to you: Is it? ;)</p>)
//     },
//     {
//         question:"What  will the  mint price  be?",
//         answer: ""
//     },
//     {
//         question:"",
//         answer: ""
//     },
//     {
//         question:"",
//         answer: ""
//     }
// ]